class PrimarySearch {
  constructor() {
    this.icon = document.getElementById('PrimarySearchIcon');
    this.icon.addEventListener('click', (e) => { e.preventDefault(); });
    this.panel = $(this.icon.getAttribute('data-target'));
    this.panel.on('shown.bs.collapse', (e) => { this.onPanelShown(e); });
    this.input = document.getElementById('PrimarySearchInput');
    this.input.addEventListener('keydown', (e) => { this.onInputKeyDown(e); });
    this.form = document.getElementById('PrimarySearchForm');
    this.form.addEventListener('submit', (e) => { this.onSearch(e); });
    this.buttonClose = document.getElementById('PrimarySearchClose');
    this.buttonClose.addEventListener('click', () => { this.close(); });
  }

  close() {
    this.input.blur();
    this.panel.collapse('hide');
  }

  onInputKeyDown(e) {
    switch (e.keyCode) {
      case 27:
        this.input.value = '';
        this.close();
        break;
      default:
    }
  }

  onPanelShown(e) {
    this.input.focus();
  }

  onSearch(e) {
    e.preventDefault();
    this.serach(this.input.value);
  }

  serach(expression) {
    const s = encodeURI(expression.trim());
    if (s !== '') {
      this.close();
      window.location.href = `/tanfolyami-naptar?expression=${s}#result`;
    }
  }
}

export default PrimarySearch;
